<mat-toolbar>
  <span><a [routerLink]="['/data/device-type']">Eszköz típusok</a>&nbsp;</span>
  <span> / {{type && type.name ? type.name : 'Új típus'}}</span>
  <span class="toolbar-spacer"></span>
  @if (type && type.id && !newType) {
    <button mat-raised-button color="warn" (click)="deleteType()">Típus törlése</button>
  }
  <button mat-raised-button color="primary" (click)="saveType()" class="ms-2">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>

@if (type) {
  <div class="row my-3">
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Típus neve</mat-label>
        <input type="text" matInput [(ngModel)]="type.name" required>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label translate>LAYOUT</mat-label>
        <mat-select [(ngModel)]="type.layout">
          @for (layout of layouts; track layout) {
            <mat-option [value]="layout[1]">{{layout[0]}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label translate>PRODUCER</mat-label>
        <input type="text" matInput [(ngModel)]="type.producer">
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label translate>TYPE</mat-label>
        <input type="text" matInput [(ngModel)]="type.type">
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="w-100">
        <mat-label translate>FUNCTION</mat-label>
        <input type="text" matInput [(ngModel)]="type.function">
      </mat-form-field>
    </div>
    @if (type.id && !newType) {
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Módosította</mat-label>
          <input type="text" matInput [(ngModel)]="type.modifiedBy" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
    @if (type.id && !newType) {
      <div class="col-md-4">
        <mat-form-field class="w-100">
          <mat-label>Módosítva</mat-label>
          <input type="text" matInput [(ngModel)]="type.modified" disabled="disabled" readonly="readonly">
        </mat-form-field>
      </div>
    }
  </div>
}

@if (type && type.id && !newType) {
  <div>
    <mat-toolbar>
      <span>Típushoz rendelt tulajdonságok</span>
      <span class="toolbar-spacer"></span>
      <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" [disabled]="!attributes || !attributes.length">Létező tulajdonság hozzárendelése</button>
      <mat-menu #menu="matMenu">
        @for (attr of attributes; track attr) {
          <button mat-menu-item (click)="onAddAttribute(attr)">
            <mat-icon>add_circle</mat-icon>
            {{attr.name}}
          </button>
        }
      </mat-menu>
      <button type="button" mat-raised-button class="ms-2" color="primary" (click)="onNewAttributeClick()">Új tulajdonság létrehozása</button>
    </mat-toolbar>
    <div class="row">
      <div class="col-md-12">
        @if (type && type.attributes.length) {
          <table class="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Név</th>
                <th>Típus</th>
                <th>Attribútum típus (yml config)</th>
                <th>Módosítva</th>
                <th>Módosította</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (attr of type.attributes; track attr) {
                <tr>
                  <td>#{{attr.id}}</td>
                  <td>{{attr.name}}</td>
                  <td>{{attr.type}}</td>
                  <td>
                    <app-select-search label="Attribute type" [list]="configs" [model]="attr.config" (modelChanged)="attr.config = $event;onAttrTypeChange(attr)"></app-select-search>
                  </td>
                  <td>{{attr.modified}}</td>
                  <td>{{attr.modifiedBy}}</td>
                  <td class="text-end">
                    <button type="button" mat-raised-button color="warn" (click)="onDeleteAttributeClick(attr)" >Delete</button>
                    <button type="button" mat-raised-button color="primary" (click)="onEditAttributeClick(attr)" class="ms-2">Edit</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        @if (!type || !type.attributes.length) {
          <p class="text-center p-3">
            Nincs tulajdonság a típushoz rendelve
          </p>
        }
      </div>
    </div>
  </div>
}
